import { render, staticRenderFns } from "./ChecktestCompleteBox.vue?vue&type=template&id=dfcc2626&"
import script from "./ChecktestCompleteBox.vue?vue&type=script&lang=ts&"
export * from "./ChecktestCompleteBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports